const scroll = {
	btnScrollToTop: document.querySelector('.js-scroll-top'),
	btnInPage: document.querySelectorAll('.in-page-nav__button'),

	init: function() {
		this.scrollToTop();
		this.inPageNav();
	},
	inPageNav: function() {
		if (this.btnInPage.length === 0) return;
		this.btnInPage.forEach((section) => {
			section.addEventListener('click', (e) => {
				e.preventDefault();
				document
					.querySelector(section.getAttribute('href'))
					.scrollIntoView({
						behavior: 'smooth',
						block: 'center',
					});
			});
		});
	},

	scrollToTop: function() {
		if (!this.btnScrollToTop) return;
		this.btnScrollToTop.addEventListener('click', () =>
			window.scrollTo({
				top: 0,
				left: 0,
				behavior: 'smooth',
			})
		);
	},
};

export default scroll;
